import React from "react";
import { useLocation } from "react-router-dom";  

import AadhaarIcon from "../assets/icons/Aadhaar.svg";
import PANIcon from "../assets/icons/PAN.svg";
import VoterIDIcon from "../assets/icons/VoterID.svg";
import PassportIcon from "../assets/icons/Passport.svg";
import DrivingLicenseIcon from "../assets/icons/DrivingLicense.svg";
import VehicleRCIcon from "../assets/icons/VehicleRC.svg";
import UANIcon from "../assets/icons/UAN.svg";
import EPFOIcon from "../assets/icons/EPFO.svg";
import CreditScoreIcon from "../assets/icons/CreditScore.svg";
import UdyogAadharIcon from "../assets/icons/UdyogAadhar.svg";
import GSTINIcon from "../assets/icons/GSTIN.svg";
import TINIcon from "../assets/icons/TIN.svg";

import globalIDIcon from "../assets/icons/Global ID Check.png"
import globalCriminalIcon from "../assets/icons/Global Criminal Search.png"
import globalSanctionsIcon from "../assets/icons/Global Sanctions and Enforcement Screening.png"
import globalEmploymentIcon from "../assets/icons/Global Employment Verification.png"
import globalEducationIcon from "../assets/icons/Global Education Verification.png"
import globalCreditSearchIcon from "../assets/icons/GlobalCreditSearchIcon.png"
import globalMediaIcon from "../assets/icons/Social Media Search.png"
import globalAddressIcon from "../assets/icons/Global Address Check.png"
import CVAnalysis from "../assets/icons/CV Analysis and GAP Check.png"
import professionalLicenseIcon from "../assets/icons/Professional License Verification.png"
import moonlightingIcon from "../assets/icons/Moonlighting Check.png"
import professionalReferenceIcon from "../assets/icons/Professional Reference Check.png"

import ownerProfilingIcon from "../assets/icons/Owner Profiling.png"
import legalInsightsIcon from "../assets/icons/Legal Insights.png"
import financialAnalysisIcon from "../assets/icons/Financial Analysis.png"
import complianceIcon from "../assets/icons/Compliance Evaluations.png"
import performanceIcon from "../assets/icons/Performance Assessments.png"
import marketIcon from "../assets/icons/Market Reputation.png"
import fieldAssessmentsIcon from "../assets/icons/Field Assessments.png"
import databaseIcon from "../assets/icons/Database Checks.png"
import { CheckCategoriesCard, CheckCategoriesContainer, CheckCategoriesGridContainer, CheckCategoriesIcon, CheckCategoriesIconWrapper, CheckCategoriesLabel, CheckCategoriesTitle } from "../assets/styles/CommonStyles";




const CheckCategories = () => {
  const location = useLocation(); 

  // Data for Instant Checks
  const instantChecksCards = [
    { icon: AadhaarIcon, label: "Aadhaar" },
    { icon: PANIcon, label: "PAN" },
    { icon: VoterIDIcon, label: "Voter ID" },
    { icon: PassportIcon, label: "Passport" },
    { icon: DrivingLicenseIcon, label: "Driving License" },
    { icon: VehicleRCIcon, label: "Vehicle RC" },
    { icon: UANIcon, label: "UAN" },
    { icon: EPFOIcon, label: "EPFO" },
    { icon: CreditScoreIcon, label: "Credit Score" },
    { icon: UdyogAadharIcon, label: "Udyog Aadhar" },
    { icon: GSTINIcon, label: "GSTIN" },
    { icon: TINIcon, label: "TIN" },
  ];

  const backgroundChecksCards = [
    { icon: globalIDIcon , label: "Global ID Check" },
    { icon: globalCriminalIcon , label: "Global Criminal Search" },
    { icon: globalSanctionsIcon , label: "Global Sanctions and<br/> Enforcement Screening" },
    { icon: globalEmploymentIcon , label: "Global Employment Verification" },
    { icon: globalEducationIcon  , label: "Global Education <br/> Verification" },
    { icon: globalCreditSearchIcon  , label: "Global Credit <br/>Search" },
    { icon: globalMediaIcon   , label: "Social Media <br/> Search" },
    { icon: globalAddressIcon , label: "Global <br/> Address Check" },
    { icon: CVAnalysis  , label: "CV Analysis <br/> and GAP Check" },
    { icon: professionalLicenseIcon , label: "Professional License <br/> Verification" },
    { icon: moonlightingIcon, label: "Moonlighting <br/> Check" },
    { icon: professionalReferenceIcon, label: "Professional <br/> Reference Check" },
  ];

  const dueDiligenceCards = [
    { icon: ownerProfilingIcon, label: "Owner Profiling" },
    { icon: legalInsightsIcon , label: "Legal Insights" },
    { icon: financialAnalysisIcon , label: "Financial Analysis" },
    { icon: complianceIcon , label: "Compliance <br/> Evaluations" },
    { icon: performanceIcon  , label: "Performance <br/> Assessments" },
    { icon: marketIcon   , label: "Market <br/> Reputation" },
    { icon: fieldAssessmentsIcon    , label: "Field <br/> Assessments" },
    { icon: databaseIcon     , label: "Database <br/> Checks" },
  ];

  let cards = [];
  let title = "";

  if (location.pathname.includes("instant-checks")) {
    cards = instantChecksCards;
    title = "Instant Checks at Your Fingertips";
  } else if (location.pathname.includes("background-checks")) {
    cards = backgroundChecksCards;
    title = "What We Verify";
  } else if (location.pathname.includes("due-diligence")) {
    cards = dueDiligenceCards;
    title = "Key Checks We Perform";
  }

  return (
    <CheckCategoriesContainer>
      <CheckCategoriesTitle>{title}</CheckCategoriesTitle>
      <CheckCategoriesGridContainer>
        {cards.map((card, index) => (
          <CheckCategoriesCard key={index}>
          <CheckCategoriesIconWrapper>

            <CheckCategoriesIcon src={card.icon} alt={card.label} />
          </CheckCategoriesIconWrapper>
            <CheckCategoriesLabel dangerouslySetInnerHTML={{ __html: card.label }}/>
          </CheckCategoriesCard>
        ))}
      </CheckCategoriesGridContainer>
    </CheckCategoriesContainer>
  );
};

export default CheckCategories;
